module.exports = __webpack_public_path__ + "static/media/check.abc59452.svg";